<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Toolbar class="p-mb-4 p-p-2">
          <template #start>
            <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('SMS Sender Names') }}</div>
<!--            <AddNewButton :label="$t('Add')" @click="addNewItem" />-->
          </template>
          <template #end>
            <div class="p-d-flex p-ai-center p-mr-2">
              <Checkbox id="sms-sender-names-show-only-pending"
                        v-model="showOnlyPending"
                        :binary="true"
                        :disabled="dataTableIsLoading"/>
              <label for="sms-sender-names-show-only-pending">
                <div class="pointer p-p-1">
                  {{ $t('showOnlyPending') }}
                </div>
              </label>
            </div>
          </template>
        </Toolbar>



        <!--  Desktop DataTable -->
        <Spinner v-if="isLoading"/>
        <!--        <DesktopDataTable v-else-if="!isLoading && !$store.state.tabletLayout"-->
        <DesktopDataTable v-else
                          :dataTableIsLoading="dataTableIsLoading"
                          :showHeader="false"
                          :tableName="$t('Locations')"
                          :itemsArrayIsEmpty="itemsArrayIsEmpty"
                          :sort="sort"
                          :showSearchInput="false"
                          :actionButtonsCount="actionButtonsCount"
                          @sort-items="sortItems"
                          :headers="[
                              {name: 'name', title: $t('Sender Name'), sortable: false},
                              {name: 'tenant', title: $t('Tenant'), sortable: false},
                              {name: 'is_active', title: $t('active'), sortable: false},
                              {name: 'status', title: $t('Status'), sortable: false},
                              {name: 'approved_at', title: $t('Approved'), sortable: false},
                              {name: 'rejected_at', title: $t('Rejected'), sortable: false},
                              {name: 'created_at', title: $t('Created'), sortable: false},
                          ]">
          <template v-slot:body>
            <tr v-for="(item, index) of items"
                :key="item.id ?? index"
                :class="{ 'updated-item': isItemUpdated(item.id) }">
              <td>
                <div class="name-cell">
                  <div class="name-cell__title">
                    <span v-if="item.name">{{ item.name }}</span>
                    <i v-else class="ti-minus"></i>
                  </div>
                </div>
              </td>

              <td>
                <div class="name-cell">
                  <div class="name-cell__title">
                    <span v-if="item.tenantName">{{ item.tenantName }}</span>
                    <i v-else class="ti-minus"></i>
                  </div>
                </div>
              </td>

              <td>
                <i class="pi pi-check green-color" v-if="item.status === 1"></i>
                <i class="pi pi-times warning-color" v-else></i>
              </td>
              <td>
                <SmsSenderStatus :state="item?.state ? +item.state : null"/>
              </td>
              <td class="table-date-line">
                <span v-if="item.approved_at">{{ formatBy(item.approved_at, item.approvedBy) }}</span>
                <i v-else class="ti-minus"></i>
              </td>
              <td class="table-date-line">
                <span v-if="item.rejected_at">{{ formatBy(item.rejected_at, item.rejectedBy) }}</span>
                <i v-else class="ti-minus"></i>
              </td>
              <td class="table-date-line">
                <span v-if="item.created_at">{{ formatBy(item.created_at, item.createdBy) }}</span>
                <i v-else class="ti-minus"/>
              </td>
             <td>
               <div class="actions">
                 <AcceptButton :disabled="dataTableIsLoading || item.state === 3"
                               v-tooltip.left="$t('Approve')"
                               @click="setSmsSenderState(item, 3)"/>
<!--                 <RemoveButton :disabled="dataTableIsLoading || item.state === 5"-->
<!--                               v-tooltip.left="$t('Reject')"-->
<!--                               @click="setSmsSenderState(item, 5)"/>-->
                 <Button :disabled="dataTableIsLoading || item.state === 5"
                         class="p-button-raised p-button-danger action-button"
                         icon="ti-close"
                         v-tooltip.left="$t('Reject')"
                         @click="setSmsSenderState(item, 5)"/>
<!--                 <EditButton/>-->
                 <DeleteButton @click="confirmItemDelete(item)"
                               :disabled="dataTableIsLoading"/>
               </div>
             </td>

              <!--        <td>-->
              <!--          <div class="p-d-flex p-jc-end">-->
              <!--            <EditButton :disabled="dataTableIsLoading || dataIsSending" @click="editItem(item)" />-->
              <!--          </div>-->
              <!--        </td>-->
            </tr>
          </template>
        </DesktopDataTable>

        <OwnPaginator v-show="items && items.length"
                      :rows="pagination.perPage"
                      :currentPage="pagination.currentPage - 1"
                      :totalPages="pagination.pageCount"
                      :totalRecords="pagination.totalCount"
                      :rowsPerPageOptions="[5,10,25,50,100,200]"
                      :pageLinkSize="11">
        </OwnPaginator>

        <TotalRecordsData :pagination="pagination" :itemsArrayIsEmpty="itemsArrayIsEmpty"/>

<!--        <SmsSenderNameModal :visible="itemModal"-->
<!--                            :item="item"-->
<!--                            @update-items="updateItems"-->
<!--                            @close="closeItemModal"/>-->

        <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                            @close="closeConfirmItemDeleteModal"
                            @delete-item="deleteItem"
                            :data="itemToDeleteData"/>
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import formatMixins from "@/mixins/formatMixins";
import showErrorsMixins from "@/mixins/showErrorsMixins";
// import SmsSenderNameModal from "@/pages/account/components/SmsSenderNameModal";
import SmsSenderStatus from "@/pages/account/components/SmsSenderStatus";
// import RemoveButton from '@/components/DataTable/RemoveButton'
import AcceptButton from '@/components/DataTable/AcceptButton'

export default {
  mixins: [ showErrorsMixins, datatableMixins, formatMixins ],
  components: { SmsSenderStatus, AcceptButton },
  // components: { SmsSenderStatus, AcceptButton},
	data() {
		return {
      fieldsExpand: 'createdBy,tenantName,approvedBy,rejectedBy',
      apiLink: 'sms-sender/all-names',
      deleteItemUrl: 'sms-sender/delete',
      routePath: '/sms-sender-names',
      sort: {
        column: 'id',
        direction: '-',
      },
		}
	},
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.checkRouteQuery()
    this.getPageData()
	},
  methods: {
    // showAll() {
    //   const query = { ...this.$route.query }
    //   delete query.pending
    //
    //   this.$router.replace({ path: this.$route.path, query })
    // },
    async changeSenderNameState(payment) {
      const paymentObj = {
        paymentId: payment.id,
        newState: payment.state === 1 ? 3 : 1,
      }
      try {
        const { status } = await httpClient.post('sales-invoice-payment/change-state', paymentObj)
        if (status === 200) {
          payment.state = paymentObj.newState
          this.updatedItem = payment.id
        }
      } catch(err) {
        this.showError(err)
      }
    },
    getPageData() {
      // if (!this.userCanGetData || this.fetchInFlight) return
      this.getItems().then(() => this.getPendingSmsSenderNamesCount())
    },
    async getPendingSmsSenderNamesCount() {
      // if (!this.userIsAdminOrModerator || !this.$store.getters.isUserReady) return false;
      if (!this.$store.getters.userCanGetData) return
      try {
        const { status, data } = await httpClient('sms-sender/pending-names-count')
        if (status === 200 && data?.success) {
          // this.$store.commit('SET_PENDING_SMS_SENDER_NAMES_COUNT', data.pendingSmsSenderNamesCount ?? 0)

          this.$store.commit('updatePendingSmsSenderNamesCount', data.pending_sms_sender_names_count ?? 0)
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      }
    },
    async getItems() {
      if (!this.userCanGetData || this.fetchInFlight) return
      this.$store.commit('SET_FETCH_IN_FLIGHT', true)
      this.dataTableIsLoading = true
      const ctrl = this.setController?.('smsSenderNames')
      try {
        // const { status, data, headers } = await httpClient(`${this.apiLink}?page=${this.pagination.currentPage}&per-page=${this.pagination.perPage}&sort=${this.sort.direction + this.sort.column}&search=${this.searchData}&expand=${this.fieldsExpand}`)
        // const showPending = this.$route.query?.pending === '1' || this.$route.query?.pending === 'true'

        const { status, data, headers } = await httpClient({
          // const { data } = await httpClient({
          url: this.apiLink,
          // method: 'post',
          params: {
            page: this.pagination.currentPage,
            'per-page': this.pagination.perPage,
            sort: this.sort.direction + this.sort.column,
            search: this.processedSearchValue ?? null,
            expand: this.fieldsExpand,
            pending: this.showOnlyPending ? 1 : 0,
          },
          signal: ctrl.signal,
          // data: {
          //   showPending: this.$route.query?.pending === '1' || this.$route.query?.pending === 'true'
          // }
        })
        if (status === 200 && data && Array.isArray(data)) {
          const hasPaginationHeaders = !!headers['x-pagination-total-count']
          if (hasPaginationHeaders) {
            this.pagination.totalCount = +headers['x-pagination-total-count']
            this.pagination.pageCount  = +headers['x-pagination-page-count']
          } else {
            this.pagination.totalCount = data.length
            this.pagination.pageCount  = 1
          }

          this.items = data

          if (!data.length) {
            this.pagination.pageCount = 1
            this.pagination.currentPage = 1
          }
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.dataTableIsLoading = false
        this.isLoading = false
        if (this._abortors?.smsSenderNames === ctrl) {
          this._abortors.smsSenderNames = null
        }
      }
    },
    async setSmsSenderState(senderName, state) {
      if (!senderName?.id || !this.$store.getters.userCanGetData) return
      if (senderName.state === state) return
      this.dataTableIsLoading = true

      const action = state === 3 ? 'confirm' : 'unconfirm'
      try {
        const { status, data } = await httpClient.post('sms-sender/set-state', { id: senderName.id, action })
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data updated'), life: this.settings.toastLife});
          this.closeConfirmItemDeleteModal()
          this.getPageData()
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.dataTableIsLoading = false
      }
    },
	},
  computed: {
    showOnlyPending: {
      get() {
        return this.$route.query.pending === '1'
            || this.$route.query.pending === 'true'
      },

      set(value) {
        const query = { ...this.$route.query }

        delete query.page

        if (value) {
          query.pending = '1'
        } else {
          delete query.pending
        }

        this.$router.replace({
          path: this.routePath,
          query,
        }).catch(() => {})
      },
    },
    itemsArrayIsEmpty() {
        return !(this.items && this.items.length)
    },
    actionButtonsCount() {
      return 3
      // if (this.$store.state.user.role === this.constants.userRoles.superAdmin || this.$store.state.user.role === this.constants.userRoles.admin) {
      //   // return 2
      //   return 1
      // } else {
      //   return 1
      // }
    },
    itemToDeleteData() {
      return this.itemToDelete?.name
    },
  }
}
</script>

<style scoped lang="scss">
td {
  height: 40px;
}
</style>